export default { // 该需求运行在销售app和合伙人app，入口车辆管理
  tabs: [
    {
      name: 'ReinstallSourceList',
      path: '/reinstall',
      component: () => import('./src/sourceList'),
      meta: {
        title: '车源列表',
        keepAlive: true
      }
    },
    {
      name: 'ReinstallSuccess',
      path: '/reinstall/success',
      component: () => import('./src/success'),
      meta: {
        title: '重新上架成功'
      }
    },
    {
      name: 'ReinstallFail',
      path: '/reinstall/fail',
      component: () => import('./src/error'),
      meta: {
        title: '重新上架失败'
      }
    },
    {
      name: 'CarRelaunch', // 该需求通过链接打开: 发送短信（包含短链） =》 打开链接
      path: '/carRelaunch',
      component: () => import('./src/relaunch/index.vue'),
      meta: {
        title: '重新上架',
        isMenu: true,
        openNetwork: true
      }
    }
  ]
}
